var map = {
	"./abius.mp4": "056e",
	"./adc.mp4": "f43b",
	"./advent.mp4": "f382",
	"./cgrt.mp4": "072b",
	"./co.mp4": "43b8",
	"./kor.mp4": "7dc2",
	"./task.mp4": "40cf",
	"./track.mp4": "39af",
	"./trata.mp4": "5586"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe72";